// extracted by mini-css-extract-plugin
module.exports = {"container":"info_container__h0cMH","image":"info_image__3KcSu","buttons":"info_buttons__1_6-1"};